import { ComponentPortal, Portal } from '@angular/cdk/portal';
import {
  AfterViewInit, ChangeDetectionStrategy,
  ChangeDetectorRef, Component,
  DestroyRef,
  inject,
  OnInit
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  PortalComponentData, SideService
} from '@app/core/layout/side.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-side-container',
    templateUrl: './side-container.component.html',
    styleUrls: ['./side-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SideContainerComponent implements OnInit, AfterViewInit {
  private readonly _destroyRef = inject(DestroyRef);
  component: PortalComponentData;
  isSideOpened$ = this._sideService.isSideOpened$();
  drawerPortal: Portal<any>;
  
  constructor(
    private _sideService: SideService,
    private _cd: ChangeDetectorRef
  ) {}
  ngAfterViewInit(): void {
    this._sideService
      .getComponent$()
      .pipe(
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe((sideComponent) => {
        if (!sideComponent) {
          return;
        }
        this.component = sideComponent;

        // HACK : utiliser le setTimout pour countourner le bug => Expression has changed after it was checked...
        setTimeout(() => {
          this.drawerPortal = new ComponentPortal(this.component.component);
          this._cd.markForCheck();
        }, 0);
      });
  }

  ngOnInit(): void {
  }

}
